import React, { useEffect, useState } from 'react';
import style from '../../css/homepage/Footer.module.css';
import { Link } from 'react-router-dom';
import { API_BASE_URL } from '../ApiConfig';
import { showCustomAlert } from '../customalert';
import { getSecureToken } from '../ApisService/apiService';
import { Container } from 'lucide-react';

const Footer = () => {
    const storedTheme = localStorage.getItem("theme") || "light";
    const [theme, setTheme] = useState(storedTheme);
    const [email, setEmail] = useState("");
    const [botTrap, setBotTrap] = useState("");


    useEffect(() => {
        if (theme === "dark") {
            document.body.classList.add("dark-mode");
        } else {
            document.body.classList.remove("dark-mode");
        }
        localStorage.setItem("theme", theme);
    }, [theme]);

    const toggleTheme = () => {
        setTheme((prevTheme) => (prevTheme === "light" ? "dark" : "light"));
    };




    const handleSubmit = async (e) => {
        e.preventDefault();
        const { secrettoken, ts } = await getSecureToken();

        try {
            const formData = new URLSearchParams();
            formData.append("email", email);
            formData.append("botTrap", botTrap);

            const response = await fetch(`${API_BASE_URL}Contact_us/Subscribe.php`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    "X-TOKEN": secrettoken,
                    "X-TIMESTAMP": ts
                },
                credentials: "include",
                body: formData.toString(),
            });

            const result = await response.json();

            // Show message based on status
            if (result.status === "success") {
                showCustomAlert(result.message);
                setEmail("");
                setBotTrap("");
            } else if (result.message === "Email is already subscribed.") {
                showCustomAlert("You have already subscribed with this email.");
            } else {
                showCustomAlert(result.message || "Something went wrong.");
            }
        } catch (error) {
            console.error("Subscription failed:", error);
            showCustomAlert("An error occurred while subscribing or Email is already subscribed.");
        }
    };




    return (
        <>
            <footer className={style["footer-section"]}>
                <div className="container">
                    <div className={`${style["footer-content"]} `}>
                        <div className="row">
                            <div className="col-xl-4 col-lg-4 mb-50">
                                <div className={style["footer-widget"]}>
                                    <div className={style["footer-logo"]}>
                                        <a className="navbar-brand" href="#">
                                            <div className={style.header__logo}>
                                                {/* <img className={style.logo_img} src="/images/logo.jpg" alt="" /> */}
                                                {/* <h1 className={style.header__title}>SWING<span className={style.header__light}>ALGO</span>ALGO</h1> */}
                                                <h1 className={style.header__title}>
                                                    <span className={style.header__light}>SWING</span><span className={style.header__light}></span>ALGO
                                                </h1>
                                            </div>
                                        </a>
                                    </div>

                                    <div className={style["footer-social-icon"]}>
                                        <span>Follow us</span>

                                        <a href="">
                                            <i className="fa-brands fa-instagram"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-6 mb-30">
                                <div className={style["footer-widget"]}>
                                    <div className={style["footer-widget-heading"]}>
                                        <h3>Useful Links</h3>
                                    </div>
                                    <ul>
                                        <li><Link to={"/"}>Home</Link></li>
                                        <li><Link to={"about_us"}>About</Link></li>
                                        {/* <li><a href="#">Services</a></li> */}
                                        {/* <li><Link to={"contact_us"}>Contact</Link></li> */}
                                        <li><Link to={"terms"}>Terms</Link></li>
                                    </ul>
                                    <ul>
                                        <li><Link to={"privacy"}>Privacy</Link></li>

                                        <li><Link to={"disclaimer"}>Disclaimer</Link></li>
                                        <li><Link to={"refundpolicy"}>Refund</Link></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-6 mb-50">
                                <div className={style["footer-widget"]}>
                                    <div className={style["footer-widget-heading"]}>
                                        <h3>Subscribe</h3>

                                    </div>
                                    <div className={style["footer-text"]}>
                                        <p>Don’t miss to subscribe to our new feeds, kindly fill the form below.</p>
                                    </div>
                                    <div className={style["subscribe-form"]}>
                                        <form onSubmit={handleSubmit}>

                                            <input
                                                type="text"
                                                name="botTrap"
                                                style={{ display: 'none' }}
                                                value={botTrap || ''}
                                                onChange={(e) => setBotTrap(e.target.value)}
                                            />
                                            <input
                                                type="email"
                                                placeholder="Email Address"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                required
                                            />
                                            <button type="submit">
                                                <i className="fa-solid fa-paper-plane"></i>
                                            </button>

                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={style["copyright-area"]}>
                    <div className='container'>

                        <div className={style["copyright-text"]}>
                            <p>
                                StockExploder Proprietor
                            </p>
                            <p>
                                Copyright © 2025, All Right Reserved
                            </p>

                        </div>
                    </div>


                </div>
            </footer>
        </>
    );
};

export default Footer;
